import { render, staticRenderFns } from "./DocumentStatusCRUD.vue?vue&type=template&id=16c701fe"
import script from "./DocumentStatusCRUD.vue?vue&type=script&lang=js"
export * from "./DocumentStatusCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports